<template>
  <div class="sa-planning">
    <div class="sa-planning-header">
      <b-row no-gutters>
        <b-col cols="4" class="text-start">
          <b-button size="sm" variant="outline-success" v-b-tooltip.hover title="Settimana Precedente" @click="onClickPreviousDay()">
            <i class="fas fa-chevron-left"></i>
          </b-button>
          <span class="sa-planning-range-label">Dal {{ formatDate(dataDal) }} al {{ formatDate(dataAl) }}</span>
          <b-button size="sm" variant="outline-success" v-b-tooltip.hover title="Settimana Successiva" @click="onClickNextDay()"> <i class="fas fa-chevron-right"></i> </b-button>
        </b-col>

        <b-col cols="7" style="display: flex; justify-content: start">
          <span v-for="area of areeOptions" :style="getVariantActiveBadgeArea(area)" :key="area.id" @click="onClickFiltroAree(area)">
            {{ area.nome }}
          </span>
        </b-col>
        <b-col cols="1" style="text-align: end">
          <b-button size="sm" class="mr-1 ml-1 no-text" variant="outline-secondary" v-b-tooltip.hover title="Download PDF" @click="onClickPrintPdf()"> <font-awesome-icon size="lg" icon="file-pdf" /> </b-button
        ></b-col>
      </b-row>
    </div>
    <div class="sa-planning-body">
      <table class="sa-planning-table" ref="tblPlanning" :key="tableKey">
        <thead class="sa-planning-table-header">
          <tr>
            <td></td>
            <template v-for="index in 7">
              <td :key="'h' + index">{{ getDate(index) }}</td>
            </template>
          </tr>
        </thead>
        <tbody ref="plnTbody">
          <template v-for="index in 24">
            <tr :key="'row1-' + index" :ref="'row' + index">
              <td class="sa-planning-table-time-cell">
                <span>{{ index }}:00</span>
              </td>
              <td v-for="day of 7" :key="day" :class="day === 7 ? 'sa-planning-table-slot-cell sa-planning-table-slot-cell-last' : 'sa-planning-table-slot-cell'" rowspan="2">
                <div :id="element.id" v-for="element of getAttivita(index, day)" :key="element.id" :style="getStyleAttivitaArea(element)">
                  <span class="sa-planning-title">{{ element.nomeAttivita }}</span>
                  <span class="sa-planning-orario">{{ element.tipoOrario === "TURNI" ? "Nel Turno" : element.ora }}</span>
                  <div style="display: flex; justify-content: end; cursor: pointer" v-html="getStato(element)" @click="onClickAttivitaDettaglio(element)"></div>
                  <b-popover :target="element.id" :show="popHoversItems[element.id]" :title="element.area"> <span v-html="getContentPopover(element)"></span></b-popover>
                </div>
              </td>
            </tr>
            <tr :key="'row2-' + index">
              <td class="sa-planning-table-time-cell"><span>&nbsp;</span></td>
            </tr>
          </template>
        </tbody>
        <tfoot></tfoot>
      </table>
      <!-- <div class="b-table-sticky-header">
				<b-table sticky-header ref="table" stacked="lg" striped hover :items="itemsFiltred" :fields="getFields" :current-page="currentPage" :per-page="perPage" :key="listKey" sort-icon-left head-variant="light" class="sa-b-table">
					<template #cell(area)="row">
						<div style="display: none">{{ (slot = getArea(row)) }}</div>
						<div>
							<span style="display: block; font-weight: 700">{{ slot.area }}</span>
							<span style="display: block; font-style: italic">Data Inizio: {{ formatDate(slot.dataInizio) }}</span>
							<span style="display: block; font-style: italic">Data Fine: {{ formatDate(slot.dataFine) }}</span>
						</div>
					</template>
					<template #cell()="row">
						<div style="display: none">{{ (slots = getDettaglioAttivita(row)) }}</div>
						<div v-for="slot in slots" :key="slot.id" :class="getClassByStato(slot.stato)">
							<span class="sa-planning-body-activiti-name">{{ slot.nomeAttivita }}</span
							>{{ "Ora: " + slot.oraProgrammata }}
						</div>
					</template>
				</b-table>
			</div> -->
    </div>
    <div class="sa-planning-footer"></div>
  </div>
</template>

<script>
// import jsPDF from "jspdf";

// import autoTable from "jspdf-autotable";
import html2pdf from "html2pdf.js";
import UtilityMixin from "../UtilityMixin";
import moment from "moment";
export default {
  mixins: [UtilityMixin],
  data() {
    return {
      tableKey: 0,
      currentPage: 1,
      perPage: 10000000,
      listKey: 0,
      dataDal: null,
      dataAl: null,
      pathResource: "/rsaplanning",
      pathResourcesAree: "/rsaaree",
      areeOptions: [],
      filtroAree: [],
      filtroStati: [],
      planningFilter: { dataRiferimento: null },
      idAccettazione: null,
      items: [],
      dateRiferiemnto: [],
      attivitaProgrammate: [],
      popHoversItems: {},
      statiOptionsFilter: [
        { stato: "PROGRAMMATA", html: `<span class="sa-planning-stato sa-planning-stato-blue">P</span>` },
        { stato: "ESEGUITA", html: `<span class="sa-planning-stato sa-planning-stato-green">E</span>` },
        { stato: "NON ESEGUITA", html: `<span class="sa-planning-stato sa-planning-stato-red">NE</span>` },
      ],
    };
  },

  mounted() {
    this.$nextTick(() => {
      const rows = this.$refs.plnTbody.querySelectorAll("tr");
      const target = rows[19];
      if (target) target.scrollIntoView({ behavior: "smooth", block: "center" });
    });
    this.idAccettazione = this.$route.query.idAccettazione;
    if (this.idAccettazione) {
      this.planningFilter.idAccettazione = this.idAccettazione;
    }
    this.changeRange();
    this.setDateRiferimento();
    this.loadAree();
  },
  computed: {
    getFields() {
      let fields = [
        {
          label: "Area",
          key: "area",
          sortable: true,
          //thStyle: "width: 7rem",
        },
      ];
      let dataInizio = this.dataDal;
      let dataFine = this.dataAl;
      let contatore = 1;
      while (dataInizio <= dataFine) {
        fields.push({
          label: moment(dataInizio).format("ddd DD MMMM"),
          key: "slot" + contatore,
          sortable: false,
          slotDateValue: dataInizio,
          //thStyle: "width: 7rem",
        });
        dataInizio = dataInizio + 86400000;
        contatore++;
      }
      return fields;
    },
  },
  methods: {
    getStato(attivita) {
      //<span class="sa-planning-stato sa-planning-stato-red">{{ element.stato }}</span>
      let stato = "";
      let cssClassColor = "";
      switch (attivita.stato) {
        case "PROGRAMMATA":
          stato = "";
          cssClassColor = "";
          break;
        case "ESEGUITA":
          stato = "V";
          cssClassColor = "sa-planning-stato-green";
          break;
        case "NON ESEGUITA":
          stato = "X";
          cssClassColor = "sa-planning-stato-red";
          break;
      }
      return `<span class="sa-planning-stato ${cssClassColor}">${stato}</span>`;
    },

    onClickAttivitaDettaglio(attivita) {
      if (!this.popHoversItems[attivita.id]) {
        this.popHoversItems[attivita.id] = true;
      } else {
        this.popHoversItems[attivita.id] = false;
      }
      console.log(this.popHoversItems[attivita.id]);

      return this.popHoversItems[attivita.id];
    },
    loadAree() {
      let me = this;
      UtilityMixin.methods.loadDataResources(me.pathResourcesAree, {}, me.loadAreeSuccess, me.loadAreeError);
    },
    loadAreeSuccess(response) {
      this.areeOptions = response.data.data.list;
      if (!this.filtroAree[0]) {
        this.areeOptions.forEach((e) => {
          let colore = "var(--bg-sidebar)";
          if (e.color) {
            colore = e.color;
          } else {
            e.color = colore;
          }
          this.filtroAree.push(e.nome);
        });
      }
    },
    loadAreeError(errror) {
      errror;
    },

    getBadgeClass(attivita) {
      let returnValue = "sa-badge";
      switch (attivita.area) {
        case "CURA DELLA PERSONA":
          returnValue = returnValue + " sa-badge-purple";
          break;
        case "SOMMINISTRAZIONE TERAPEUTICA":
          returnValue = returnValue + " sa-badge-blue";
          break;
        case "AREA RIABILITATIVA":
          returnValue = returnValue + " sa-badge-green";
          break;
        default:
          returnValue = returnValue + " sa-badge-altro";
      }
      return returnValue;
    },
    onClickFiltroStati(stato) {
      console.log(stato);
    },
    onClickFiltroAree(area) {
      this.filtroAree;
      if (!this.isActiveFiltroAree(area)) {
        this.filtroAree.push(area.nome);
      } else {
        let index = this.filtroAree.indexOf(area.nome);
        this.filtroAree.splice(index, 1);
      }
    },
    isActiveFiltroAree(area) {
      return this.filtroAree.some((e) => {
        return e == area.nome;
      });
    },
    getContentPopover(attivita) {
      let returnValue = `<strong>${attivita.id}</strong>`;
      switch (attivita.stato) {
        case "PROGRAMMATA":
          returnValue = `
          <label>Data Ora Programmata:</label>
          <strong>${this.getDataFormattata(attivita.attivita.dataOraPrevista)}</strong>
          `;
          break;
        case "ESEGUITA":
          returnValue = `
          <label>Operatore:</label>
          <strong>${attivita.attivita.cognomeNomeOperatore}</strong>
          <br />
          <label>DataOra Esecuzione:</label>
          <strong>${this.getDataFormattata(attivita.attivita.dataOraEffettuata)}</strong>
          `;
          break;
        case "NON ESEGUITA":
          returnValue = `
          <label>Operatore:</label>
          <strong>${attivita.attivita.cognomeNomeOperatore}</strong>
          <br />
          <label>DataOra Esecuzione:</label>
          <strong>${this.getDataFormattata(attivita.attivita.dataOraEffettuata)}</strong>
          <br />
          <label>Nota:</label>
          <small style="font-weight:700">${attivita.attivita.note}</small>
          `;
          break;
      }
      return returnValue;
    },
    getVariantActiveBadgeArea(area) {
      let style = {};
      if (this.isActiveFiltroAree(area)) {
        let areaSelezionata = this.areeOptions.filter((e) => e.nome == area.nome);
        let coloreArea = areaSelezionata[0].color;
        style = this.setStyle(coloreArea);
      } else {
        style = this.setStyle("gray");
      }
      return style;
    },
    setStyle(colore) {
      let style = {
        borderRadius: "5px",
        borderLeft: "4px solid " + colore,
        borderTop: "1px solid " + colore,
        borderBottom: "1px solid " + colore,
        borderRight: "1px solid " + colore,
        padding: "7px",
        marginBottom: "5px !important",
        marginRight: "4px",
        cursor: "pointer",
        fontSize: "smaller",
      };
      return style;
    },

    getStyleAttivitaArea(item) {
      return this.setStyle(item.color);
    },

    getDate(index) {
      return moment(this.dateRiferiemnto[index]).format("dddd DD");
    },
    getDataFormattata(data) {
      return moment(data).format("DD/MM/yyyy HH:mm");
    },
    getWeekRowClass(index) {
      if (index === 0) {
        return "sa-planning-week-row sa-planning-week-header";
      } else {
        return "sa-planning-week-row-body";
      }
    },
    getClassByStato(stato) {
      return "sa-stato-" + stato.toLowerCase().replace(" ", "-");
    },

    loadData() {
      let me = this;
      me.$emit("beforeLoadData");

      UtilityMixin.methods.loadDataResources(me.pathResource, me.planningFilter, me.loadDataSuccess, me.loadDataError);
    },
    setDateRiferimento() {
      this.dateRiferiemnto = [];
      let dataInizio = this.dataDal;
      let dataFine = this.dataAl;
      let contatore = 1;
      while (dataInizio <= dataFine) {
        this.dateRiferiemnto[contatore] = dataInizio;
        dataInizio = dataInizio + 86400000;
        contatore++;
      }
    },
    getAttivita(ora, dataIndex) {
      let data = moment(this.dateRiferiemnto[dataIndex]).format("YYYYMMDD");
      ora = ora < 10 ? "0" + ora : ora;
      let attivita = this.attivitaProgrammate.filter((element) => element.ora.substring(0, 2) == ora && element.data == data && this.filtroAree.includes(element.area));
      attivita.forEach((e) => {
        this.popHoversItems[e.id] = false;
      });
      return attivita;
    },
    loadDataSuccess(response) {
      let me = this;
      me.items = response.data.data.list;
      me.items.forEach((element, index) => {
        let tipoOrario = null;
        if (element.attivitaSchedulate.length > 0) {
          if (element.listaOrari.length > 0) {
            tipoOrario = element.listaOrari[0].tipo;
          }
        }
        element.attivitaSchedulate.forEach((attivita, attivitaIndex) => {
          let data = moment(attivita.dataOraPrevista).format("YYYYMMDD");
          let ora = moment(attivita.dataOraPrevista).format("HH:mm");
          let areaColor = me.areeOptions.filter((e) => e.nome === attivita.area);
          this.attivitaProgrammate.push({ id: index + "-" + attivitaIndex, tipoOrario: tipoOrario, data: data, ora: ora, color: areaColor[0].color, stato: attivita.stato, nomeAttivita: attivita.nomeAttivita, area: attivita.area, element: element, attivita: attivita });
        });
        this.tableKey++;
      });
      me.$emit("afterLoadData");
    },
    loadDataError(error) {
      let me = this;
      console.log(error);
      me.$emit("afterLoadData");
    },
    getArea(row) {
      let slot = { area: row.item.area, dataInizio: row.item.dataInizio, dataFine: row.item.dataFine };
      return slot;
    },
    getDettaglioAttivita(row) {
      let slot = [];
      row.item.attivitaSchedulate.forEach((element) => {
        let dataSlot = moment(row.field.slotDateValue).format("DD/MM/YYYY");
        let dataAttivita = moment(element.dataOraProgrammata).format("DD/MM/YYYY");
        if (dataSlot === dataAttivita) {
          slot.push({ id: self.crypto.randomUUID(), nomeAttivita: element.nomeAttivita, stato: element.stato, area: row.item.area, oraProgrammata: moment(element.dataOraProgrammata).format("HH:mm") });
        }
      });

      return slot;
    },
    onClickPreviousDay() {
      let dataDal = this.dataDal - 86400000;
      this.changeRange(dataDal);
    },
    onClickNextDay() {
      let dataDal = this.dataDal + 86400000;
      this.changeRange(dataDal);
    },
    changeRange(dataDal) {
      this.dataDal = dataDal ? dataDal : new Date().getTime();
      this.dataAl = this.dataDal + 6 * 86400000;
      this.planningFilter.dataRiferimento = this.dataDal;
      this.loadData();
    },
    getSlotData(ora, giorno) {
      console.log(ora);
      console.log(giorno);
    },

    onClickPrintPdf() {
      const element = this.$refs.tblPlanning;

      // 🔹 Opzioni PDF
      const options = {
        margin: 1,
        filename: "planning.pdf",
        image: { type: "jpeg", quality: 0.9 },
        html2canvas: { scale: 2 }, // qualità migliore
        jsPDF: { unit: "mm", format: "a4", orientation: "landscape" }, // orizzontale
      };

      // // 🔹 Genera e scarica il PDF
      html2pdf().set(options).from(element).save();
    },
    // onClickPrintPdf() {
    // 	const doc = new jsPDF("l", "pt", "a4");
    // 	doc.text("Pianificazione Settimanale", doc.internal.pageSize.getWidth() / 2, 30, { align: "center" });

    // 	// 🔹 Chiamata corretta per autoTable in moduli ES
    // 	autoTable(doc, {
    // 		html: this.$refs.tblPlanning,
    // 		theme: "striped",
    // 		headStyles: { fillColor: [41, 128, 185], textColor: 255 },
    // 		styles: {
    // 			fontSize: 7,
    // 			cellPadding: 3,
    // 			lineWidth: 0.1, // spessore del bordo
    // 			lineColor: [0, 0, 0],
    // 		},
    // 		didParseCell: function (data) {
    // 			// Trasforma il contenuto della cella in testo
    // 			let cellText = "";

    // 			if (data.cell.raw instanceof HTMLElement) {
    // 				// se è un nodo HTML
    // 				cellText = data.cell.raw.innerText || data.cell.raw.textContent;
    // 			} else {
    // 				// se è già testo o altro tipo
    // 				cellText = String(data.cell.raw);
    // 			}

    // 			// Sostituire <span> o altre interruzioni con newline
    // 			cellText = cellText.replace(/\n+/g, "\n").trim();

    // 			// Se vuoi forzare linee separate, puoi split se ci sono dei delimitatori
    // 			if (cellText === "P") {
    // 				data.cell.styles.halign = "right";
    // 			}
    // 			data.cell.text = cellText.split("\n");
    // 		},
    // 	});

    // 	doc.save("planning.pdf");
    // },
  },
};
</script>

<style scoped></style>
